/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Edit_TitleInputs */

const en_admin_posts_edit_title = /** @type {(inputs: Admin_Posts_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Post`)
};

/**
* | output |
* | --- |
* | "Edit Post" |
*
* @param {Admin_Posts_Edit_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_edit_title = /** @type {((inputs?: Admin_Posts_Edit_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Edit_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_edit_title(inputs)
});
export { admin_posts_edit_title as "admin.posts.edit_title" }